<script>

    import moment from 'moment-timezone';
    import Constants from '@/utils/constants'
    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';

    import PageNumbers from '@/utils/page-number-constants';

    var FileSaver = require('file-saver');

    export default {
        name: "common",
        data() {
            return {
                isFirefox: false,
                isSafari: false,

                vuexIndexArray: [
                    {
                        'setter': (newIndex) => {
                            this.setRealtimeMalwareDetectionIndex(newIndex);
                        },
                        'getter': () => {
                            return this.getRealtimeMalwareDetectionIndex;
                        },
                        'name': 'RealTimeMalwareDetection'
                    },
                    {
                        'setter': (newIndex) => {
                            this.setMalwareSoftwareEfficiencyIndex(newIndex);
                        },
                        'getter': () => {
                            return this.getMalwareSoftwareEfficiencyIndex;
                        },
                        'name': 'MalwareSoftwareEfficiency'
                    },
                    // INFO this comment lines may be uncommented due to approval of malware threat forecast widget
                    // {
                    //     'setter': (newIndex) => {
                    //         this.setMalwareThreatForecastIndex(newIndex);
                    //     },
                    //     'getter': () => {
                    //         return this.getMalwareThreatForecastIndex;
                    //     },
                    //     'name': 'MalwareThreatForecast'
                    // },
                    {
                        'setter': (newIndex) => {
                            this.setTargetedPhishingIndex(newIndex);
                        },
                        'getter': () => {
                            return this.getTargetedPhishingIndex;
                        },
                        'name': 'TargetedPhishing'
                    },
                    // INFO: this component is commented out because if it is intended to be displayed again.
                    // {
                    //     'setter': (newIndex) => {
                    //         this.setAttackometerIndex(newIndex);
                    //     },
                    //     'getter': () => {
                    //         return this.getAttackometerIndex;
                    //     },
                    //     'name': 'Attackometer'
                    // },
                    // {
                    //     'setter': (newIndex) => {
                    //         this.setMalwareTimerIndex(newIndex);
                    //     },
                    //     'getter': () => {
                    //         return this.getMalwareTimerIndex;
                    //     },
                    //     'name': 'MalwareTimer'
                    // },
                    {
                        'setter': (newIndex) => {
                            this.setRiskScoreIndex(newIndex);
                        },
                        'getter': () => {
                            return this.getRiskScoreIndex;
                        },
                        'name': 'RiskScore'
                    },
                    {
                        'setter': (newIndex) => {
                            this.setPartnerRiskScoreIndex(newIndex);
                        },
                        'getter': () => {
                            return this.getPartnerRiskScoreIndex;
                        },
                        'name': 'PartnerRiskScore'
                    },
                    // INFO: this component is commented out because if it is intended to be displayed again.
                    // {
                    //     'setter': (newIndex) => {
                    //         this.setHourZeroPreventionTimelineIndex(newIndex);
                    //     },
                    //     'getter': () => {
                    //         return this.getHourZeroPreventionTimelineIndex;
                    //     },
                    //     'name': 'HourZeroPrevention'
                    // }

                    // TODO: this comment lines will be removed due to approval of threat time line widget
                    // ,
                    // {
                    //     'setter': (newIndex) => {
                    //         this.setThreatTimeLineIndex(newIndex);
                    //     },
                    //     'getter': () => {
                    //         return this.getThreatTimeLineIndex;
                    //     },
                    //     'name': 'ThreatTimeLine'
                    // },
                ],
                RESPONSIVE_BIG: 1,
                RESPONSIVE_MIDDLE: 2,
                RESPONSIVE_SMALL: 3,

                DATA_BREACH_RISK_GROUP_ENUM: 1,
                ENDPOINTS_RISK_GROUP_ENUM: 2,
                SERVERS_RISK_GROUP_ENUM: 3,
                NETWORK_SECURITY_RISK_GROUP_ENUM: 4,
                BRAND_AND_USER_RISK_GROUP_ENUM: 5,

                risk_group_array: [
                    {
                        "enum_no": 1,
                        "group_name": "Threats OnData Breach"
                    },
                    {
                        "enum_no": 2,
                        "group_name": "Threats On Endpoints"
                    },
                    {
                        "enum_no": 3,
                        "group_name": "Threats On Servers"
                    },
                    {
                        "enum_no": 4,
                        "group_name": "Threats On Network Security"
                    },
                    {
                        "enum_no": 5,
                        "group_name": "Threats On Brand & User"
                    }
                ],

                roles: {
                    "0": 'TI_VI_PROGRAM_MANAGER',
                    "1": 'TI_ACCOUNT_MANAGER_RSM',
                    "2": 'TI_SALES/SALES_ENGINEER',
                    "3": 'TI_CUSTOMER_ON_BOARDING_PROCE',
                    "4": 'DATA_ENRICHMENT_ANALYST',
                    "5": 'EXPERT_DATA_ENRICHMENT_ANALYS',
                    "6": 'TI_ENRICHMENT_PROCESS',
                    "7": 'TI_SALES/SALES_ENGINEER',
                    "8": 'TI_SALES/SALES_ENGINEER',
                    "9": 'TI_VI_MSSP_USER'
                },

                status_enum: {
                    "1": 'New',
                    "2": 'Pending',
                    "3": 'In Analysis',
                    "4": 'Pool',
                    "5": 'Assigned',
                    "6": 'Live Demo',
                    "7": 'POC',
                    "8": 'Registered',
                    "9": 'Inactive'
                },

                valid_date_formats: [
                    {
                        format: 'YYYY',
                        unit: 'year'
                    },
                    {
                        format: 'YYYY.MM',
                        unit: 'month'
                    },
                    {
                        format: 'YYYY.MM.DD',
                        unit: 'day'
                    },
                    {
                        format: 'YYYY.MM.DD HH',
                        unit: 'hour'
                    },
                    {
                        format: 'YYYY.MM.DD HH:mm',
                        unit: 'minute'
                    },
                    {
                        format: 'YYYY.MM.DD HH:mm:ss',
                        unit: 'second'
                    }
                ]
            }
        },
        computed: {
            ...mapGetters([
                "getSelectedPartner",
                "getComodoAdminRole"
            ])
        },
        methods: {
            utcStringToLocalDate(utcDate, format) {
                if (utcDate) {
                    var testDateUtc = moment.utc(utcDate);
                    var localDate = moment(testDateUtc).local();
                    // Test Purposes
                    // console.log("UTC : " + utcDate);
                    // console.log("Local : " + localDate.format('YYYY.MM.DD HH:mm:ss'));
                    return localDate.format(format);
                }
            },
            changeGivenDateToRange(date) {
                for (let i = 0; i < this.valid_date_formats.length; i++) {
                    if (moment(date, this.valid_date_formats[i].format, true).isValid()) {
                        let start = moment(date, this.valid_date_formats[i].format).startOf(this.valid_date_formats[i].unit);
                        let end = moment(date, this.valid_date_formats[i].format).endOf(this.valid_date_formats[i].unit);
                        return {
                            'start': start.format('YYYY-MM-DD HH:mm:ss'),
                            'end': end.format('YYYY-MM-DD HH:mm:ss'),
                            'isSearching': true
                        }
                    }
                }
                return {
                    'isSearching': false
                }
            },
            getThreatPageType(pageNumber) {
                switch (pageNumber) {
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 46:
                        return Constants.ThreatPageTypes.Matched;
                    case 17:
                    case 18:
                    case 19:
                    case 20:
                    case 21:
                    case 22:
                    case 23:
                    case 24:
                    case 25:
                    case 26:
                    case 27:
                    case 28:
                    case 29:
                        return Constants.ThreatPageTypes.Global;
                    case 33:
                    case 34:
                    case 35:
                    case 36:
                    case 37:
                    case 38:
                    case 39:
                    case 40:
                    case 41:
                    case 42:
                    case 43:
                    case 44:
                    case 45:
                    case 60:
                    case 61:
                    case 62:
                        return Constants.ThreatPageTypes.Partner;
                    case 47:
                    case 48:
                    case 49:
                    case 50:
                    case 51:
                    case 52:
                    case 53:
                    case 54:
                    case 55:
                    case 56:
                    case 57:
                    case 58:
                    case 59:
                        return Constants.ThreatPageTypes.Industry;
                    default:
                        return 0;
                }
            },
            shuffle(a) {
                for (let i = a.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [a[i], a[j]] = [a[j], a[i]];
                }
                return a;
            },
            getRandomNumber(end) {
                return Math.floor(Math.random() * end)
            },
            getRandomInRange(from, to, fixed) {
                return (Math.random() * (to - from) + from).toFixed(fixed) * 1;
            },
            sortyByKey(key, arr, asc) {
                return arr.sort(function (a, b) {
                    var keyA = a[key];
                    var keyB = b[key];
                    // Compare the 2 dates
                    if (asc) {
                        if (keyA < keyB) return -1;
                        if (keyA > keyB) return 1;
                    } else {
                        if (keyA < keyB) return 1;
                        if (keyA > keyB) return -1;
                    }
                    return 0;
                });
            },
            getDurationInSeconds(start, end) {
                return (end - start) / 1000;
            },
            getBrowserName() {
                var userAgent = navigator.userAgent;
                var browsers = {chrome: /chrome/i, safari: /safari/i, firefox: /firefox/i, ie: /internet explorer/i};

                for (var key in browsers) {
                    if (browsers[key].test(userAgent)) {
                        return key;
                    }
                }

                return 'unknown';
            },
            hasValidResponse(response) {
                if (response && response.body)
                    return true;
                return false;
            },
            formatDate(date) {
                if (date)
                    return moment.tz(date, "YYYY-MM-DD'T'HH:mm:ssZ", moment.tz.guess()).format("MM/DD/YYYY, HH:mm:ss z");
                return "";
            },
            formatDateYYYYMMDD(date) {
                var d = date,
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();

                if (month.length < 2) month = '0' + month;
                if (day.length < 2) day = '0' + day;

                return [year, month, day].join('');
            },
            formatTimeHHMMSS(datetime) {
                var d = datetime,
                    hours = d.getHours().toString(),
                    minutes = d.getMinutes().toString(),
                    seconds = d.getSeconds().toString();

                if (hours.length < 2) hours = '0' + hours;
                if (minutes.length < 2) minutes = '0' + minutes;
                if (seconds.length < 2) seconds = '0' + seconds;

                return [hours, minutes, seconds].join('');

            },
            formatDateForDataTable(date, format) {
                if (date)
                    return moment.tz(date, format ? format : "YYYY-MM-DD'T'HH:mm:ss", moment.tz.guess()).format("YYYY.MM.DD HH:mm:ss");
                return "";
            },
            // expects inputs as "2018-01-19 21:21:21"
            getTimePassedInSeconds(beginning, end) {
                if (!end)
                    end = moment.utc()
                else
                    end = moment.utc(end);

                var ms = end.diff(moment.utc(beginning));
                return ms / 1000;
            },
            getTimePassedInHoursAndMinutesAndSeconds(beginning, end) {
                var seconds = this.getTimePassedInSeconds(beginning, end);
                var hours = Math.floor(seconds / (3600))
                var remaining = seconds - (hours * 3600);
                var minutes = Math.floor(remaining / 60);
                remaining = remaining - (minutes * 60);

                return {
                    hours: hours,
                    minutes: minutes,
                    seconds: parseInt(remaining)
                }
            },
            getTwoDigitValue(value) {
                if (value < 10)
                    return "0" + value;
                return value;
            },
            openInNewTab(url) {
                var win = window.open(url, '_blank');
                win.focus();
            },
            openInSameTab(url) {
                var win = window.open(url, "_self");
                win.focus();
            },
            downloadFile: function (filename, url, extension) {
                if (url != 'None') {
                    var xhr = new XMLHttpRequest();
                    xhr.responseType = 'blob';
                    xhr.onload = function () {
                        var a = document.createElement('a');
                        a.href = window.URL.createObjectURL(xhr.response); // xhr.response is a blob
                        a.download = filename + '.' + extension; // Set the file name.
                        a.style.display = 'none';
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    };

                    xhr.open('GET', url);
                    xhr.send();
                }
            },
            showErrorMessage: function (message) {
                this.$toasted.show(message, {
                    position: "bottom-center",
                    duration: 5000,
                    type: 'error'
                });
            },
            showSuccessMessage: function (message) {
                this.$toasted.show(message, {
                    position: "bottom-center",
                    duration: 5000,
                    type: 'success'
                })
            },
            showEmailInModal: function (self, row, pageName, log_page_name) {
                let log_start = Date.now();
                let partner_id = null;
                if (self.incomingThreatPageType === Constants.ThreatPageTypes.Partner) {
                    partner_id = self.getSelectedPartner
                }

                if (row.mail_content && row.mail_content !== 'None') {
                    let sender_ip_domain = "";
                    if (row.sender_ip && row.sender_domain) {
                        sender_ip_domain = row.sender_ip + "/" + row.sender_domain;
                    } else {
                        sender_ip_domain = row.sender_ip + row.sender_domain;
                    }
                    self.$refs.emailDisplayModal.showModal(row.mail_content, row.subject, log_page_name,
                        row.mail_content, partner_id, row.email_date, sender_ip_domain, row.recipient_domain, row.recipient_email);
                    this.saveLog(self, log_page_name, 'Eml Open Clicked (Mail Url: ' + row.mail_content + ')',
                        this.getDurationInSeconds(log_start, Date.now()), partner_id);
                } else if (row.eml_origin && row.eml_origin !== 'None') {
                    self.loading = true;
                    self.$http.post(Constants.INTELLIGENCE_BACKEND_URL + "/file/updateeml", {
                        id: row.id,
                        eml_origin: row.eml_origin,
                        page_name: pageName,
                        is_global: self.incomingThreatPageType === Constants.ThreatPageTypes.Global
                    })
                        .then(response => { // Success
                            row.mail_content = response.body.data;
                            let sender_ip_domain = "";
                            if (row.sender_ip && row.sender_domain) {
                                sender_ip_domain = row.sender_ip + "/" + row.sender_domain;
                            } else {
                                sender_ip_domain = row.sender_ip + row.sender_domain;
                            }
                            self.$refs.emailDisplayModal.showModal(row.mail_content, row.subject, log_page_name,
                                row.mail_content, partner_id, row.email_date, sender_ip_domain, row.recipient_domain, row.recipient_email);
                            self.loading = false;
                            this.saveLog(self, log_page_name, 'Eml Open Clicked (Mail Url: ' + row.mail_content + ')',
                                this.getDurationInSeconds(log_start, Date.now()), partner_id);
                        }, response => { //Error
                            self.$toasted.show('Server error, please try again.', {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'error'
                            });
                            self.loading = false;
                        });
                }
            },
            verdictSearchHandlerCommon(searchString, component, pageName, comingFromSearchBar) {
                if (searchString) {
                    this.saveLog(component, pageName, 'A search has been made from Verdict Search Bar. (Searched String: ' + searchString + ')', null, null);
                    let path = Constants.INTELLIGENCE_BACKEND_URL + '/validate_verdict_search';
                    let body = {
                        "verdict_search": searchString
                    };
                    this.$http.post(path, body).then(response => {
                        this.verdictSearchResponseHandler(response, comingFromSearchBar);
                    }, response => {
                        this.verdictShowErrorTos("Request Error. Please contact with the support.");
                    });
                } else {
                    this.verdictShowErrorTos("Please insert a non-empty value.");
                }
            },
            verdictSearchResponseHandler(response, comingFromSearchBar) {
                if (response.data.return_code === Constants.ReturnCodes.Success) {
                    this.openUrlInIframe(response.data.data, Constants.IframeSelections.Verdict, comingFromSearchBar);
                } else if (response.data.return_code === Constants.ReturnCodes.Error
                    || response.data.return_code === Constants.ReturnCodes.ServerError
                    || response.data.return_code === Constants.ReturnCodes.ArgumentError) {
                    this.showErrorTos(response.data.data);
                }
            },
            verdictShowErrorTos(errorMessage) {
                $("#app").css("opacity", "0.4");
                let div = document.createElement("div");
                div.className += "overlay";
                document.body.appendChild(div);
                this.$toasted.show(errorMessage, {
                    position: "bottom-center",
                    duration: 2500,
                    type: 'error'
                });
                setTimeout(function () {
                    $("#app").css("opacity", "1");
                    $(".overlay").remove();
                }, 2500)
            },
            downloadFileWithBackend: function (fileName, url, extension) {
                var a = document.createElement("a");
                a.href = Constants.INTELLIGENCE_BACKEND_URL + '/file/getfile?url=' + url + '&filename=' + fileName +
                    '&extension=' + extension;
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            },
            downloadPcap: function (self, row, pageName) {
                self.loading = true;
                let start_time = Date.now();
                let log_text_prefix = '';
                let page_name = '';
                let log_page = '';
                let partner_id = null;

                switch (self.incomingThreatPageType) {
                    case Constants.ThreatPageTypes.Global:
                        log_text_prefix = 'Global Threats';
                        break;
                    case Constants.ThreatPageTypes.Matched:
                        log_text_prefix = 'Notifications';
                        break;
                    case Constants.ThreatPageTypes.Partner:
                        log_text_prefix = 'Partner Threats';
                        partner_id = this.getSelectedPartner;
                        break;
                    case Constants.ThreatPageTypes.Industry:
                        log_text_prefix = 'Industry Threats';
                        break;
                    default:
                        log_text_prefix = 'Unknown';
                        break;
                }

                switch (pageName) {
                    case Constants.PageNames.TargetedMalware:
                        page_name = 'Targeted Malware';
                        break;
                    case Constants.PageNames.CCHosting:
                        page_name = 'C&C Hosting';
                        break;
                    default:
                        page_name = 'Unknown';
                        break;
                }

                log_page = log_text_prefix + ' - ' + page_name;

                if (row.pcap != null && row.pcap !== '' && row.pcap !== 'None') {
                    self.downloadFileWithBackend(row.sha1, row.pcap, 'pcap');
                    self.loading = false;
                    this.saveLog(self, log_page, 'Pcap Download (Sha1: ' + row.sha1 + ')',
                        this.getDurationInSeconds(start_time, Date.now()), partner_id);
                } else if (row.pcap_origin != null && row.pcap_origin !== '' && row.pcap_origin !== 'None') {
                    self.$http.post(Constants.INTELLIGENCE_BACKEND_URL + "/file/pcaporign", {
                        rec_id: row.id,
                        pcap_orign: row.pcap_origin,
                        isGlobal: self.incomingThreatPageType === Constants.ThreatPageTypes.Global,
                        page_name: pageName
                    })
                        .then(response => { // Success
                            self.downloadFileWithBackend(row.sha1, response.body.data, 'pcap');
                            row.pcap = response.body.data;
                            self.loading = false;
                            this.saveLog(self, log_page, 'Pcap Download (Sha1: ' + row.sha1 + ')',
                                this.getDurationInSeconds(start_time, Date.now()), partner_id);

                        }, response => { // Error
                            self.$toasted.show('File error, please try again.', {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'error'
                            });
                            self.loading = false;
                        });
                } else {
                    self.$toasted.show('File error, please try again.', {
                        position: "bottom-center",
                        duration: 5000,
                        type: 'error'
                    });

                    self.loading = false;
                }
            },
            saveLog: function (self, page, log_text, duration, partner_id) {
                self.$http.post(Constants.INTELLIGENCE_BACKEND_URL + "/log/save", {
                    page: page,
                    log_text: log_text,
                    duration: duration,
                    partner_id: partner_id
                }).then(response => {
                    // Success
                }, response => {
                    // Error
                });
            },
            saveCatLog: function (self, log_id, parameters) {
                if (this.getUserRole(this.getComodoAdminRole) == "TI_VI_MSSP_USER") {
                    self.$http.post(Constants.INTELLIGENCE_BACKEND_URL + "/cat/log", {
                        log_id: log_id,
                        parameters: parameters
                    }).then(response => {
                        // Success
                    }, response => {
                        // Error
                    });
                }
            },
            setUserInformation: function (loginData) {
                if (loginData.data["return_code"] == "Success") {
                    // console.log('login is successful.');
                    // console.log(loginData.data['user']);
                    // $scope.user.enterprise_id = parseInt(loginData.data['user']['id']);
                    var is_userActive = loginData.data.data['user']['is_active'];
                    if (is_userActive) {
                        this.setEnterpriseId(loginData.data.data['user']['id']);
                        this.setEnterpriseName(loginData.data.data['user']['enterprise_name']);
                        this.setEnterpriseStatus(loginData.data.data['user']['status']);
                        this.setComodoUserLogo(loginData.data.data['user']['logo']);
                        this.setComodoUserObject(loginData.data.data['user']['email']);
                        this.setIsActiveUser(loginData.data.data['user']['is_active']);
                        this.setUserFirstName(loginData.data.data['user']['first_name']);
                        this.setUserLastName(loginData.data.data['user']['last_name']);
                        this.setUserPhoneNumber(loginData.data.data['user']['phone_number']);
                        this.setIsPrimaryUser(loginData.data.data['user']['isprimary']);
                        this.setApiKey(loginData.data.data['user']['api_key']);
                        this.setUserPermissions(JSON.parse(loginData.data.data['user']['permissions']));
                        if (loginData.data.data['user'].hasOwnProperty('manager')
                            && loginData.data.data['user']['manager'].hasOwnProperty('role')) {
                            this.setComodoAdminRole(loginData.data.data['user']['manager'].role);
                            this.setComodoAdminName(loginData.data.data['user']['manager'].manager_email);
                            this.setManagerSession(loginData.data.data['user']['manager'].session_id);
                            return true;
                        } else {
                            this.setComodoAdminRole(null);
                            this.setComodoAdminName(null);
                            this.setManagerSession(null);
                        }
                    }
                } else {

                    if (loginData.data["return_code"] == 'License Expired') {
                        this.$toasted.show("License Expired", {
                            position: "bottom-center",
                            duration: 5000,
                            type: 'error'
                        });
                    }
                    return false;
                }
            },
            indexOfArray(val, array) {
                var hash = {}, i;
                for (i = 0; i < array.length; i++) {
                    hash[array[i]] = i;
                }
                return (hash.hasOwnProperty(val)) ? hash[val] : -1;
            },
            getPagePath(pageNumber) {
                for (let pageKey in PageNumbers) {
                    let page = PageNumbers[pageKey];
                    if (page.number == pageNumber)
                        return page.path;
                }
            },
            getPageNumberFromPath(path) {
                for (let pageKey in PageNumbers) {
                    let page = PageNumbers[pageKey];
                    if (page.path == path) {
                        return page.number;
                    }
                }
            },
            logOutUser: function () {
                this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/logout')
                    .then(result => {
                        this.removeAllFromStore();
                    }, result => {
                        this.removeAllFromStore();
                    });
                this.$router.push('/login');

            },
            removeAllFromStore: function () {
                this.setEnterpriseId(null);
                this.setEnterpriseName(null);
                this.setEnterpriseStatus(null);
                this.setComodoUserLogo(null);
                this.setComodoUserObject(null);
                this.setIsActiveUser(null);
                this.setComodoAdminRole(null);
                this.setComodoAdminName(null);
                this.setManagerSession(null);
                this.setUserFirstName(null);
                this.setUserLastName(null);
                this.setUserPhoneNumber(null);
                this.setIsPrimaryUser(false);
                this.setWhiteLabelingData(null);
                this.setIsPhoneModalDisplayed(null);
                // this.setRealtimeMalwareDetectionIndex(4);
                // this.setMalwareSoftwareEfficiencyIndex(3);
                // this.setMalwareThreatForecastIndex(8);
                // this.setTargetedPhishingIndex(7);
                // this.setAttackometerIndex(6);
                // this.setMalwareTimerIndex(5);
                // this.setRiskScoreIndex(1);
                // this.setPartnerRiskScoreIndex(2);
            },
            removeWidgetIndex: function () {
                if (this.getPartnerRiskScoreIndex > 0) {
                    this.setPartnerRiskScoreIndex(-1);
                    // let widgetIndexArrayWithoutDouble = this.vuexIndexArray.filter(oneWidgetElement => oneWidgetElement.getter() !== this.threatTimeLineIndex);
                    // widgetIndexArrayWithoutDouble.map(oneWidgetElement => {
                    //     if (oneWidgetElement.getter() > this.getPartnerRiskScoreIndex) {
                    //         /**
                    //          * we need to shift widget backwards
                    //          * except double widget
                    //          * instead of shift double widget
                    //          * we need to shift the widget which is after from double widget
                    //          * two times backwards.
                    //          */
                    //         if (oneWidgetElement.getter() === this.threatTimeLineIndex + 1) {
                    //             oneWidgetElement.setter(oneWidgetElement.getter() - 2);
                    //         } else {
                    //             oneWidgetElement.setter(oneWidgetElement.getter() - 1);
                    //         }
                    //     }
                    // });
                }

                this.arrangeIndexes();
            },
            arrangeIndexes: function () {
                let idx_array = [];
                for (let i = 0; i < this.vuexIndexArray.length; i++) {
                    idx_array.push({
                        'name': this.vuexIndexArray[i].name,
                        'index': this.vuexIndexArray[i].getter()
                    })
                }

                idx_array.sort((a, b) => a.index - b.index);

                let arranged_index = 1;
                for (let i = 0; i < idx_array.length; i++) {
                    if (idx_array[i].index !== -1) {
                        if (idx_array[i].name === 'ThreatTimeLine' && arranged_index % 2 !== 1) {
                            let before = idx_array.filter(x => x.index === arranged_index - 1
                                && x.name !== 'ThreatTimeLine');
                            if (before != null) {
                                before[0].index = before[0].index + 1;
                                idx_array[i].index = arranged_index - 1;
                                arranged_index = before[0].index;
                            }

                        } else {
                            idx_array[i].index = arranged_index;
                        }

                        arranged_index++;
                    }
                }


                for (let i = 0; i < idx_array.length; i++) {
                    let name = idx_array[i].name;
                    let incoming = this.vuexIndexArray.filter(x => x.name === name);
                    if (incoming != null) {
                        incoming[0].setter(idx_array[i].index);
                    }
                }
            },
            removeWidgetIndexForPartner: function () {
                if (this.getPartnerRiskScoreIndex < 0) {
                    // /**
                    //  * we need to shift widget forwards
                    //  * except double widget
                    //  * instead of shift double widget
                    //  * we need to shift the widget which is after from double widget
                    //  * two times forward.
                    //  */
                    // let widgetIndexArrayWithoutDouble = this.vuexIndexArray.filter(oneWidgetElement => oneWidgetElement.getter() !== this.threatTimeLineIndex);
                    // widgetIndexArrayWithoutDouble.map(oneWidgetElement => {
                    //     if (oneWidgetElement.getter() > 1) {
                    //         /**
                    //          * we need to shift widget backwards
                    //          * except double widget
                    //          * instead of shift double widget
                    //          * we need to shift the widget which is after from double widget
                    //          * two times backwards.
                    //          */
                    //         if (oneWidgetElement.getter() === this.threatTimeLineIndex - 1) {
                    //             oneWidgetElement.setter(oneWidgetElement.getter() + 2);
                    //         } else {
                    //             oneWidgetElement.setter(oneWidgetElement.getter() + 1);
                    //         }
                    //     }
                    // });
                    this.setPartnerRiskScoreIndex(2);
                }
                this.arrangeIndexes();
            },
            getStatus: function (status) {
                return this.status_enum[status];
            },
            getUserRole: function (roleId) {
                return this.roles[roleId];
            },
            convertArrayOfObjectsToCSV: function (args) {
                var result, ctr, keys, columnDelimiter, lineDelimiter, data;

                data = args.data || null;
                if (data == null || !data.length) {
                    return null;
                }

                columnDelimiter = args.columnDelimiter || ',';
                lineDelimiter = args.lineDelimiter || '\n';

                keys = Object.keys(data[0]);

                result = '';
                result += keys.join(columnDelimiter);
                result += lineDelimiter;

                data.forEach(function (item) {
                    ctr = 0;
                    keys.forEach(function (key) {
                        if (ctr > 0) result += columnDelimiter;

                        result += item[key];
                        ctr++;
                    });
                    result += lineDelimiter;
                });

                return result;
            },
            downloadExportContent: function (data, fileName) {
                if (this.selectedExportValue === Constants.ExportTypes.JSON) {
                    data = this.removeUnneccessaryData(data);
                }
                let link = document.createElement('a');
                var mimeType = 'application/octet-stream';

                if (window.navigator.msSaveBlob) { // IE10
                    window.navigator.msSaveBlob(new Blob([data], {
                        type: mimeType
                    }), fileName);
                } else if (URL && 'download' in link) { //html5 A[download]
                    link.href = URL.createObjectURL(new Blob([data], {
                        type: mimeType
                    }));
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    location.href = 'data:application/octet-stream,' + encodeURIComponent(data); // only this mime type is supported
                }
            },
            downloadCSV: function (jsonData, args) {
                var data, filename, link;
                var csv = this.convertArrayOfObjectsToCSV({
                    data: jsonData,
                    columnDelimiter: ','
                });
                if (csv == null) return;

                filename = args.filename || 'export.csv';

                // var file = new File([csv], filename, {type: "data:text/csv;charset=utf-8"});
                // FileSaver.saveAs(file);
                data = csv;
                link = document.createElement('a');
                var mimeType = 'application/octet-stream';

                if (window.navigator.msSaveBlob) { // IE10
                    window.navigator.msSaveBlob(new Blob([data], {
                        type: mimeType
                    }), filename);
                } else if (URL && 'download' in link) { //html5 A[download]
                    link.href = URL.createObjectURL(new Blob([data], {
                        type: mimeType
                    }));
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    location.href = 'data:application/octet-stream,' + encodeURIComponent(data); // only this mime type is supported
                }
            },
            uuidv4() {
                var uuid = "", i, random;
                for (i = 0; i < 32; i++) {
                    random = Math.random() * 16 | 0;

                    if (i == 8 || i == 12 || i == 16 || i == 20) {
                        uuid += "-"
                    }
                    uuid += (i == 12 ? 4 : (i == 16 ? (random & 3 | 8) : random)).toString(16);
                }
                return uuid;
            },
            openUrlInIframe(URL, selection, comingFromSearchBar) {
                this.setIframeSelection(selection);
                this.setIframeUrl(URL);
                this.setIsComingFromSearchBar(comingFromSearchBar);
                this.setIsIframeVisible(true);

                // this.$router.push(this.getPagePath(PageNumbers.VERDICT_AND_KILLCHAIN.number));
                // window.open(this.getPagePath(PageNumbers.VERDICT_AND_KILLCHAIN.number));
            },
            ...mapActions([
                "setEnterpriseId",
                "setEnterpriseName",
                "setEnterpriseStatus",
                "setComodoUserLogo",
                "setComodoUserObject",
                "setIsActiveUser",
                "setComodoAdminRole",
                "setComodoAdminName",
                "setManagerSession",
                "setUserFirstName",
                "setUserLastName",
                "setUserPhoneNumber",
                "setIsPrimaryUser",
                "setApiKey",
                "setUserPermissions",
                "setRealtimeMalwareDetectionIndex",
                "setMalwareSoftwareEfficiencyIndex",
                // INFO this comment lines may be uncommented due to approval of malware threat forecast widget
                // "setMalwareThreatForecastIndex",
                "setTargetedPhishingIndex",
                // INFO: this component is commented out because if it is intended to be displayed again.
                // "setAttackometerIndex",
                "setMalwareTimerIndex",
                "setRiskScoreIndex",
                "setPartnerRiskScoreIndex",
                // INFO: this component is commented out because if it is intended to be displayed again.
                // "setHourZeroPreventionTimelineIndex"
                "setIframeUrl",
                "setIframeSelection",
                "setIsIframeVisible",
                "setIsComingFromSearchBar",
                "setWhiteLabelingData",
                "setIsPhoneModalDisplayed"
            ])
        },
        mounted() {
            this.isFirefox = typeof InstallTrigger !== 'undefined';
            var ua = navigator.userAgent.toLowerCase();
            if (ua.indexOf('safari') != -1) {
                if (ua.indexOf('chrome') > -1) {
                } else {
                    this.isSafari = true;
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/utils/Common.vue